import React from 'react';
import { CircleAlert } from 'lucide-react';
import { Skeleton } from './ui/skeleton';
import { Input } from './ui/input';

const FormSkeleton = (props) => {
	return (
		<>
			{props.apiError ? (
				<div className="flex flex-col items-center text-center">
					<CircleAlert color={props.errorColor} size={90} />
					<h3 className="break-words py-5 text-3xl sm:text-4xl md:text-5xl">
						{props.apiErrorMessage}
					</h3>
					<p className="break-words pt-5 text-lg sm:text-2xl">
						Please try again or contact support@chekkit.io
					</p>
				</div>
			) : (
				<div className="flex w-full flex-col items-center space-y-3">
					<Skeleton className="h-10 w-3/5 rounded-full" />
					<Skeleton className="h-5 w-4/5 rounded-xl" />
					<Input
						className="text-base sm:text-sm"
						value={''}
						placeholder="Loading..."
						disabled={true}
						readOnly
					/>
					<Input
						className="text-base sm:text-sm"
						value={''}
						placeholder="Loading..."
						disabled={true}
						readOnly
					/>
					<Skeleton className="h-36 w-full rounded-md" />
					<Skeleton className="h-10 w-full rounded-md" />
				</div>
			)}
		</>
	);
};

export default FormSkeleton;
